import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
if (typeof document !== 'undefined') {
  const head = document.head;
  const heroImage = 'https://cdn.magicpatterns.com/uploads/tsZ9Zvn6Mxrk88kgjojFJY/Ajuste_a_420x420.png';
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  preconnect.crossOrigin = 'anonymous';
  head.appendChild(preconnect);
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.href = heroImage;
  preload.as = 'image';
  preload.setAttribute('fetchpriority', 'high');
  head.appendChild(preload);
}
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-278" data-mp="2xzyn9trnihlm" />);
}